import { legacy_createStore as createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { thunk } from 'redux-thunk'
import { authReducer } from './reducers/authReducer'
import { classReducer } from './reducers/classReducer'
import { studentReducer } from './reducers/studentReducer'
import { evaluationReducer } from './reducers/evaluationReducer'
import { taskReducer } from './reducers/taskReducer'
import { communicationReducer } from './reducers/communicationReducer'
import { calendarReducer } from './reducers/calendarReducer'
import checkingReducer from './reducers/checkingReducer'
import { employmentReducer } from './reducers/employmentReducer'

const intialState = {}
const appReducer = combineReducers({
    auth: authReducer,
    classes: classReducer,
    students: studentReducer,
    evaluations: evaluationReducer,
    tasks: taskReducer,
    communications: communicationReducer,
    calendar: calendarReducer,
    checking: checkingReducer,
    employment: employmentReducer
})

const reducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    reducer,
    intialState,
    composeEnhancer(applyMiddleware(thunk))
)

export default store
